import {
  create,
  ErrorType,
  isPlayerSupported,
  MediaPlayer,
  PlayerError,
  PlayerEventType,
  PlayerState,
  Quality,
  TextCue,
  TextMetadataCue,
} from 'amazon-ivs-player';
// import { setupForm, getFormStream } from '../common/form-control';

/**
 * These imports are loaded via the file-loader, and return the path to the asset.
 * We use the TypeScript compiler (TSC) to check types; it doesn't know what this WASM module is, so let's ignore the error it throws (TS2307).
 */
// @ts-ignore
//import wasmBinaryPath from 'amazon-ivs-player/dist/assets/amazon-ivs-wasmworker.min.wasm';
//import wasmWorkerPath from 'amazon-ivs-player/dist/assets/amazon-ivs-wasmworker.min.js';
import { FontAwesomeConfigurations } from '../../utils/Configuration/FontAwesomeConfiguration';

interface IVSPlayerState {
  PlayerState: any;
  PlayerEventType: any;
}
class AmazonIVSPlayer implements VideoPlayer {
  mDiv: JQuery<HTMLElement>;
  mEmbedHtml: string = '';
  url: string;
  mVideo: any = null;

  mContent: JunoContent;
  mDuration: moment.Moment | number = 0;
  mClickText: string = CrowdHub_App.LANG.TAP_TO_JOINVIDEO;
  mContentType: string = 'application/x-mpegURL';
  mFillMode: string = 'aspect';
  videoId: number = 0;
  mPlaying: boolean = false;
  mIsStream: boolean = true;
  mAutoPlay: any = false;
  mClickedToPlay: boolean = false;
  mShowControls: boolean = true;
  mWatchedSome: boolean = false;
  mWatchedHalf: boolean = false;
  mWatched: boolean = false;
  mWatchedFull: boolean = false;
  playerControls: JQuery<HTMLElement>;
  playerOverlay: JQuery<HTMLElement>;
  playerState: IVSPlayerState = { PlayerState: '', PlayerEventType: '' };
  btnPlay: JQuery<HTMLElement>;
  btnMute: JQuery<HTMLElement>;
  btnSettings: JQuery<HTMLElement>;
  btnFullscreen: JQuery<HTMLElement>;
  settingsMenu: JQuery<HTMLElement>;
  videoElement: HTMLElement;
  lastVolume: number = 100;

  private _audioIsBlocked = false;
  private _isAttemptingReconnect: boolean = false;
  private _backoffTimer: any = null;
  private _miniTimer: any = null;
  private _constructorParams: any;
  private _structure = {
    id: 'custom-ivs-player',
    style: 'ivs_player ui_full_width ui_full_height ui_relative',
    children: [
      {
        style: 'click_to_play_container ui_absolute ui_full_width ui_full_height ',
        children: [
          {
            style: 'click_ui ui_textalign_center center_xy',
            children: [
              {
                style: 'click_icon',
                interior: HGEN.faicon({
                  style: FontAwesomeConfigurations.ICON_PLAY_SOLID,
                }),
              },
              {
                style: 'click_text',
              },
            ],
          },
        ],
      },
      {
        id: 'video-container',
        style: 'video_container ui_relative ui_full_width ui_full_height',
        children: [
          {
            style: 'player_wrapper ui_relative',
            children: [
              { style: 'aspect_spacer' },
              {
                style: 'ui_absolute ui_full_width ui_full_height top_0',
                children: [
                  {
                    id: 'overlay',
                    style: 'ui_absolute top_0 bottom_0',
                    children: [
                      {
                        id: 'player-controls',
                        style: 'ui_absolute top_0 bottom_0',
                        children: [
                          {
                            style: 'player_controls_inner ui_absolute bottom_0',
                            children: [
                              {
                                style: 'player_controls_inner_left',
                                children: [
                                  {
                                    id: 'play',
                                    style: 'btn btn_icon btn_play',
                                    children: [
                                      {
                                        style: 'icon icon_play',
                                        interior: HGEN.faicon({
                                          style: FontAwesomeConfigurations.ICON_PLAY,
                                        }),
                                      },
                                      {
                                        style: 'icon icon_pause',
                                        interior: HGEN.faicon({
                                          style: FontAwesomeConfigurations.ICON_PAUSE,
                                        }),
                                      },
                                    ],
                                  },
                                  {
                                    id: 'volume-container',
                                    style: '',
                                    children: [
                                      {
                                        id: 'mute',
                                        style: 'btn btn_icon btn_mute',
                                        children: [
                                          {
                                            style: 'icon icon_volume_up',
                                            interior: HGEN.faicon({
                                              style: FontAwesomeConfigurations.ICON_VOLUME_HIGH,
                                            }),
                                          },
                                          {
                                            style: 'icon icon_volume_off',
                                            interior: HGEN.faicon({
                                              style: FontAwesomeConfigurations.ICON_VOLUME_XMARK,
                                            }),
                                          },
                                        ],
                                      },
                                      {
                                        id: 'volume-slider-container',
                                        style: '',
                                      },
                                    ],
                                  },
                                  {
                                    id: 'time-count-container',
                                    style: '',
                                    children: [
                                      {
                                        id: 'time-counter',
                                        style: '',
                                        children: [
                                          {
                                            style: '',
                                            id: 'time-count-current',
                                            interior: '0:00',
                                          },
                                          {
                                            style: '',
                                            interior: '&nbsp;/&nbsp;',
                                          },
                                          {
                                            style: '',
                                            id: 'time-count-duration',
                                            interior: '0:00',
                                          },
                                        ],
                                      },
                                    ],
                                  },
                                ],
                              },
                              {
                                style: 'player_controls_inner_right',
                                children: [
                                  {
                                    id: 'settings',
                                    style: 'btn btn_icon btn_settings_off',
                                    children: [
                                      {
                                        style: 'icon icon_settings',
                                        interior: HGEN.faicon({
                                          style: FontAwesomeConfigurations.ICON_GEAR,
                                        }),
                                      },
                                      {
                                        id: 'settings-menu',
                                        style: 'ui_absolute',
                                        children: [
                                          {
                                            id: 'settings-menu-header',
                                            interior: 'Quality Settings',
                                          },
                                          {
                                            style: 'settings-menu-content',
                                          },
                                        ],
                                      },
                                    ],
                                  },
                                  {
                                    id: 'fullscreen',
                                    style: 'btn btn_icon btn_fullscreen_off',
                                    children: [
                                      {
                                        style: 'icon icon_fullscreen_on',
                                        interior: HGEN.faicon({
                                          style: FontAwesomeConfigurations.ICON_EXPAND,
                                        }),
                                      },
                                      {
                                        style: 'icon icon_fullscreen_off',
                                        interior: HGEN.faicon({
                                          style: FontAwesomeConfigurations.ICON_COMPRESS,
                                        }),
                                      },
                                    ],
                                  },
                                ],
                              },
                            ],
                          },
                          {
                            id: 'scrub-bar-container',
                            style: 'ui_absolute',
                          },
                        ],
                      },
                    ],
                  },
                  { id: 'video-player-container' },
                ],
              },
            ],
          },
        ],
      },
    ],
  };

  constructor(aConstructorParams: any) {
    this._constructorParams = aConstructorParams;
    this.videoId = this._constructorParams.id;
    this.url = this._constructorParams.url;
    this.mAutoPlay = aConstructorParams.autoPlay;
    this.playerState.PlayerState = PlayerState;
    this.playerState.PlayerEventType = PlayerEventType;
    this.mContent = aConstructorParams.content;

    if (this._constructorParams.clickText != null) {
      this.mClickText = this._constructorParams.clickText;
    }

    this.mDiv = $(HGEN.tree(this._structure));

    this.mDiv.find('.click_text').text(this.mClickText);
    this.playerOverlay = this.mDiv.find('#overlay');
    this.playerControls = this.mDiv.find('#player-controls');
    this.btnPlay = this.mDiv.find('#play');
    this.btnMute = this.mDiv.find('#mute');
    this.btnSettings = this.mDiv.find('#settings');
    this.btnFullscreen = this.mDiv.find('#fullscreen');
    this.settingsMenu = this.mDiv.find('#settings-menu');

    if (this._constructorParams.container) {
      this._constructorParams.container.append(this.mDiv);
    }

    this.embed();
  }

  private _addEventListeners(): void {
    // Attach event listeners
    this.mVideo.addEventListener(this.playerState.PlayerState.PLAYING, () => {
      // do something when the player starts playing
      if (CrowdHub_App.CONFIG.VERBOSE_GENERAL_LOGGING) {
        console.info('Player State - PLAYING');
        this._updateScrubBar();
      }
    });
    this.mVideo.addEventListener(this.playerState.PlayerState.ENDED, () => {
      // do something when the player ends
      if (CrowdHub_App.CONFIG.VERBOSE_GENERAL_LOGGING) {
        console.info('Player State - ENDED');
      }
    });
    this.mVideo.addEventListener(this.playerState.PlayerEventType.BUFFERING, () => {
      // do something when the player buffers
      if (CrowdHub_App.CONFIG.VERBOSE_GENERAL_LOGGING) {
        console.info('Player State - BUFFERING');
      }
    });
    this.mVideo.addEventListener(this.playerState.PlayerEventType.TIME_UPDATE, () => {
      // do something when the player buffers
      if (CrowdHub_App.CONFIG.VERBOSE_GENERAL_LOGGING) {
        console.info('Player State - TIME_UPDATE');
      }
      this._updateScrubBar();
      this.onTimeChange();
    });
    this.mVideo.addEventListener(this.playerState.PlayerState.READY, () => {
      // do something when the player is ready to go
      if (CrowdHub_App.CONFIG.VERBOSE_GENERAL_LOGGING) {
        console.info('Player State - READY');
      }

      Accessibility.clickAndKeypress(this.mDiv.find('.click_to_play_container'), e => {
        // we trigger a click of the video element to allow audio and autoplay
        this.mDiv.find('video').trigger('click');
        this._audioIsBlocked = false;

        this.mute(false);
        this.play();
        this.mDiv.find('.click_to_play_container').hide();
        this.mDiv.find('.click_to_play_container .click_icon').show();
        this.mDiv.find('.click_to_play_container .click_text').text(this.mClickText);
      });

      if (!this.mVideo.isMuted() && this.mAutoPlay) {
        this.mDiv.find('.click_to_play_container').trigger('click');
      }
    });
    this.mVideo.addEventListener(this.playerState.PlayerEventType.ERROR, err => {
      console.warn('Player Event - ERROR:', err);
      // TODO do we need this still?
      // if (err.type == "ErrorNetwork" || err.type == "ErrorNetworkIO" || err.type == "ErrorNotAvailable") {
      // }
      this.mDiv.find('.click_to_play_container .click_icon').hide();
      this.mDiv.find('.click_to_play_container').show();
      if (!this._isAttemptingReconnect) {
        this._startBackoffReconnection();
      }
    });
    this.mVideo.addEventListener(this.playerState.PlayerEventType.TEXT_METADATA_CUE, cue => {
      const metadataText = cue.text;
      const position = this.mVideo.getPosition().toFixed(2);
      if (CrowdHub_App.CONFIG.VERBOSE_GENERAL_LOGGING) {
        console.info(
          `PlayerEvent - TEXT_METADATA_CUE: "${metadataText}". Observed ${position}s after playback started.`,
        );
      }
    });
    this.mVideo.addEventListener(this.playerState.PlayerEventType.AUDIO_BLOCKED, () => {
      this._audioIsBlocked = true;
      if (CrowdHub_App.CONFIG.VERBOSE_GENERAL_LOGGING) {
        console.info('Player Audio Blocked');
      }
      // audio is blocked but lets at least play muted
      this.mute(true);
      this.play();
      // let user know they are muted tho due to browser
      this.mDiv.find('.click_to_play_container .click_text').text(CrowdHub_App.LANG.AWS_IVS_AUDIO_BLOCKED_TEXT);
      this.mDiv.find('.click_to_play_container .click_icon').show();
      this.mDiv.find('.click_to_play_container').show();
    });
    // make hoverable to show controls
    this.playerOverlay[0].addEventListener(
      'mouseover',
      e => {
        this.playerOverlay[0].classList.add('player_hover');
      },
      false,
    );
    this.playerOverlay[0].addEventListener('mouseout', e => {
      this.playerOverlay[0].classList.remove('player_hover');
    });

    // Play/Pause Controls
    Accessibility.clickAndKeypress(this.btnPlay[0], e => {
      if (this.btnPlay[0].classList.contains('btn_play')) {
        this.pause();
      } else {
        this.play();
      }
    });

    // Mute/Unmute Controls
    Accessibility.clickAndKeypress(this.btnMute[0], e => {
      if (this.btnMute[0].classList.contains('btn_mute')) {
        this.mute(true);
        this.mDiv.find('#volume-slider').val(0);
      } else {
        this.mute(false);
        this.mDiv.find('#volume-slider').val(this.lastVolume);
      }
    });

    // Fullscreen On/Off
    Accessibility.clickAndKeypress(this.btnFullscreen[0], e => {
      if (this.btnFullscreen[0].classList.contains('btn_fullscreen_off')) {
        this._toggleFullscreen(true);
      } else {
        this._toggleFullscreen(false);
      }
    });
  }

  private _addAmbienceBackground(): void {
    this.mDiv.prepend('<canvas id="ambience" style="ui_full_width ui_full_height ui_absolute top_0"></canvas>');
    // Video to canvas
    var canvas = this.mDiv.find('#ambience')[0];
    var ctx = canvas.getContext('2d');

    this.mVideo.addEventListener(this.playerState.PlayerState.PLAYING, () => {
      var can = () => {
        ctx.drawImage(this.videoElement, 0, 0, canvas.width, canvas.height);
        requestAnimationFrame(can);
      };
      requestAnimationFrame(can);
    });
  }

  private _addVideoQualityControls(): void {
    // Create Quality Options
    var createQualityOptions = (obj, i) => {
      var q = document.createElement('a');
      var qText = document.createTextNode(obj.name);
      this.settingsMenu.find('.settings-menu-content')[0].appendChild(q);
      q.classList.add('settings-menu-item');
      q.appendChild(qText);

      Accessibility.clickAndKeypress(q, e => {
        this.mVideo.setQuality(obj);
        closeSettingsMenu();
        return false;
      });
    };

    // Close Settings menu
    var closeSettingsMenu = () => {
      this.btnSettings[0].classList.remove('btn_settings_on');
      this.btnSettings[0].classList.add('btn_settings_off');
      this.settingsMenu[0].classList.remove('open');
    };

    // Settings controls
    this.btnSettings[0].addEventListener(
      'click',
      e => {
        let qualities = this.mVideo.getQualities();

        // Empty the settings menu
        while (this.settingsMenu.find('.settings-menu-content')[0].firstChild) {
          this.settingsMenu
            .find('.settings-menu-content')[0]
            .removeChild(this.settingsMenu.find('.settings-menu-content')[0].firstChild);
        }

        if (this.btnSettings[0].classList.contains('btn_settings_off')) {
          // fill the settings menu with all the available qualities
          for (var i = 0; i < qualities.length; i++) {
            createQualityOptions(qualities[i], i);
          }
          this.btnSettings[0].classList.remove('btn_settings_off');
          this.btnSettings[0].classList.add('btn_settings_on');
          this.settingsMenu[0].classList.add('open');
        } else {
          closeSettingsMenu();
        }
      },
      false,
    );

    // Close Settings menu if user clicks outside the player
    // ! NOTE: Cannot use Accessibility for this. It breaks the site
    window.addEventListener('click', e => {
      if (this.playerOverlay[0].contains(e.target)) {
      } else {
        closeSettingsMenu();
      }
    });
  }

  private _addVolumeSlider(): void {
    this.mDiv.find('#volume-slider-container').append(
      HGEN.input({
        id: 'volume-slider',
        type: 'range',
        min: '0',
        max: '100',
        value: '100',
      }),
    );
    this.mDiv.find('#volume-slider').on('change', event => {
      this.mVideo?.setVolume(Number(Number(event.target.value / 100).toFixed(1)));
      if (event.target.value == 0) {
        this.mute(true);
      } else {
        this.lastVolume = event.target.value;
        this.mute(false);
      }
    });
  }

  private _addScrubBar(): void {
    this.mDiv.find('#scrub-bar-container').append(
      HGEN.input({
        id: 'scrub-slider',
        type: 'range',
        min: '0',
        max: '100',
        value: '0',
      }),
    );
    this.mDiv.find('#scrub-slider').on('change', event => {
      this.mVideo?.seekTo(Number(event.target.value));
    });
  }

  private _updateScrubBar(): void {
    if (CrowdHub_App.CONFIG.AWS_IVS_SHOW_SCRUB_BAR) {
      this.mDiv.find('#scrub-slider').attr('max', this.mVideo.getDuration());
      this.mDiv.find('#time-count-duration').text(this._calculateTimeCount(this.mVideo.getDuration()));
      this.mDiv.find('#scrub-slider').val(this.mVideo.getPosition());
      this.mDiv.find('#time-count-current').text(this._calculateTimeCount(this.mVideo.getPosition()));
    }
  }

  private _calculateTimeCount(timeInSeconds: number): string {
    if (timeInSeconds == Infinity) {
      return 'LIVE';
    }

    var hms = new Date(timeInSeconds * 1000).toISOString().substr(12, 7);
    return hms;
  }

  private _toggleFullscreen(aBool: boolean): void {
    if (this.mVideo) {
      if (aBool) {
        this._enterFullscreen();
      } else {
        this._exitFullscreen();
      }
    }
  }

  private _enterFullscreen(): void {
    this.mDiv.find('.video_container').addClass('fullscreen');
    this.btnFullscreen[0].classList.remove('btn_fullscreen_off');
    this.btnFullscreen[0].classList.add('btn_fullscreen_on');
    openFullscreen(this.mDiv.find('.video_container')[0]);
    document.addEventListener('fullscreenchange', () => {
      this._onFullscreenChange();
    });
  }

  private _exitFullscreen(): void {
    this.mDiv.find('.video_container').remove('fullscreen');
    this.btnFullscreen[0].classList.remove('btn_fullscreen_on');
    this.btnFullscreen[0].classList.add('btn_fullscreen_off');
    closeFullscreen();
  }

  private _onFullscreenChange(): void {
    if (!document.fullscreenElement) {
      document.removeEventListener('fullscreenchange', this._onFullscreenChange);
      this.mDiv.find('.video_container').remove('fullscreen');
      this.btnFullscreen[0].classList.remove('btn_fullscreen_on');
      this.btnFullscreen[0].classList.add('btn_fullscreen_off');
    }
  }

  private _startBackoffReconnection(): void {
    var containerClickText = this.mDiv.find('.click_to_play_container .click_text');
    this._isAttemptingReconnect = true;
    var start = moment.now();
    var backoffInterval = 1.15; // this will increase the counter by 15% every time.
    var intervalStart = 5;

    if (this._backoffTimer) {
      window.clearTimeout(this._backoffTimer);
    }
    if (this._miniTimer) {
      window.clearTimeout(this._miniTimer);
    }

    this._miniTimer = null;
    var miniTimerCtr = 0;
    var reconnectAttempt = 1;
    var reconnectTimeoutInMS = CrowdHub_App.CONFIG.AWS_IVS_RECONNECT_TIMEOUT_IN_MS;
    // ! NOTE: here we are forcing the timeout to be a minimum of 1 minute. Comment out in order to test at lower limits.
    reconnectTimeoutInMS =
      CrowdHub_App.CONFIG.AWS_IVS_RECONNECT_TIMEOUT_IN_MS > 60000
        ? CrowdHub_App.CONFIG.AWS_IVS_RECONNECT_TIMEOUT_IN_MS
        : 60000;
    var reconnectTimeoutInMinutes = Number(reconnectTimeoutInMS / 1000 / 60).toFixed(0);

    // left these functions for scope rather than passing or making globals
    var startMiniTimer = () => {
      if (this._miniTimer) {
        window.clearTimeout(this._miniTimer);
      }
      if (this.mVideo.getState() != this.playerState.PlayerState.PLAYING) {
        this._miniTimer = setTimeout(() => {
          if (miniTimerCtr < 7) {
            // 7 is random just to give the viewer some pretty dots to look at
            containerClickText.html(
              `${containerClickText.html()}<span style='color:var(--brand-color);font-size:64px;'>.</span>`,
            );
          } else {
            miniTimerCtr = 0;
            containerClickText.html(
              `${CrowdHub_App.LANG.AWS_IVS_CLICK_TEXT}<br><span style='color:var(--brand-color);font-size:64px;'>.</span>`,
            );
          }
          startMiniTimer();
        }, 1000);
      }
      miniTimerCtr++;
    };

    var reconnect = () => {
      if (this.mVideo.getState() != this.playerState.PlayerState.PLAYING) {
        let attemptedTime = moment.now() - start;
        if (attemptedTime < reconnectTimeoutInMS) {
          // 300000ms is 5 mins - 15 seconds due to 15% increase (300000%17=14.951)
          intervalStart = Number(Number(intervalStart * backoffInterval).toFixed(0));
          containerClickText.html(
            `${CrowdHub_App.LANG.AWS_IVS_CLICK_TEXT}<br><span style='color:var(--brand-color);font-size:64px;'>.</span>`,
          );

          // this is where we attempt to load the video again.
          this.mVideo.load(this.url != '' ? this.url : this.videoId);

          window.clearTimeout(this._backoffTimer);
          this._backoffTimer = setTimeout(() => {
            if (CrowdHub_App.CONFIG.VERBOSE_GENERAL_LOGGING) {
              console.group(`Retry #${reconnectAttempt} Info`);
              console.info(`Retrying now, next retry in ${intervalStart} seconds`);
              console.info(`Retrying seconds attempted: ${attemptedTime / 1000}`);
              console.info(`Retrying seconds left: ${(reconnectTimeoutInMS - attemptedTime) / 1000}`);
              console.groupEnd();
            }
            reconnect();
          }, intervalStart * 1000);
          reconnectAttempt++;
        } else {
          if (this._backoffTimer) {
            window.clearTimeout(this._backoffTimer);
          }
          if (this._miniTimer) {
            window.clearTimeout(this._miniTimer);
          }
          containerClickText.html(
            `Session attempted to reconnect for ${reconnectTimeoutInMinutes} minutes. <br>Please refresh your page to try again.`,
          );
          if (CrowdHub_App.CONFIG.VERBOSE_GENERAL_LOGGING) {
            console.info(`Attempted reconnection for ${reconnectTimeoutInMinutes} minutes straight.`);
          }
        }
      }
    };

    startMiniTimer();
    reconnect();
  }

  destroy(): void {
    this.mDiv.remove();
    if (this._miniTimer) {
      window.clearTimeout(this._miniTimer);
    }
    if (this._backoffTimer) {
      window.clearTimeout(this._backoffTimer);
    }
  }

  embed(): void {
    var videoSrc = this.url != null && this.url != '' ? this.url : this.videoId;
    // dont add controls to the player. We add them with our own html and always show them with IVS
    this.mEmbedHtml = '<video id="video-player" style="ui_absolute top_0" playsinline></video>';
    this.mDiv.find('#video-player-container').html(this.mEmbedHtml);
    this.videoElement = this.mDiv.find('#video-player')[0];
    if (isPlayerSupported) {
      // Initialize player

      this.mVideo = create({
        wasmWorker: new URL('https://cdn-juno.s3.amazonaws.com/dev/amazon-ivs-wasmworker.min.js').toString(),
        wasmBinary: new URL('https://cdn-juno.s3.amazonaws.com/dev/amazon-ivs-wasmworker.min.wasm').toString(),
        // wasmWorker: new URL(wasmWorkerPath, document.URL).toString(),
        // wasmBinary: new URL(wasmBinaryPath, document.URL).toString(),
      });

      this.mVideo.attachHTMLVideoElement(this.videoElement);

      if (CrowdHub_App.CONFIG.VERBOSE_GENERAL_LOGGING) {
        console.log('IVS Player version:', this.mVideo.getVersion());
      }

      this._addEventListeners();

      // Setup stream and play, can't play with audio initially
      this.mVideo.setAutoplay(this.mAutoPlay);

      if (this.mAutoPlay) {
        this.mDiv.find('.click_to_play_container').trigger('click');
        this.play();
      } else {
        this.pause();
      }

      if (CrowdHub_App.CONFIG.VERBOSE_GENERAL_LOGGING) {
        this.mVideo.setLogLevel('debug');
      } else {
        this.mVideo.setLogLevel('error');
      }

      this.mVideo.load(videoSrc);

      // Set the volume to 1.0 -- range is 0.0f - 1.0f
      this.mVideo.setVolume(1.0);

      if (CrowdHub_App.CONFIG.AWS_IVS_USE_AMBIENT_BACKGROUND) {
        this._addAmbienceBackground();
      }

      if (CrowdHub_App.CONFIG.AWS_IVS_SHOW_QUALITY_CONTROLS) {
        this._addVideoQualityControls();
      } else {
        this.mDiv.find('#settings').hide();
      }

      if (CrowdHub_App.CONFIG.AWS_IVS_SHOW_AUDIO_VOLUME_SLIDER) {
        this._addVolumeSlider();
      }

      if (CrowdHub_App.CONFIG.AWS_IVS_SHOW_SCRUB_BAR) {
        this._addScrubBar();
      } else {
        this.mDiv.find('#time-count-container').hide();
      }
    }
  }

  pause(): void {
    if (this.mVideo) {
      this.mVideo.pause();
    }
    this.btnPlay[0].classList.remove('btn_play');
    this.btnPlay[0].classList.add('btn_pause');
  }

  play(): void {
    if (this.mVideo) {
      if (!this.mClickedToPlay && !this.mAutoPlay) {
        this.mClickedToPlay = true;
        App.INSTANCE.firehoseActivity(
          ANALYTICS_CONFIGURATION.FIREHOSE_OBJECTS.OBJECT_CONTENT,
          this.mContent.Id,
          null,
          App.INSTANCE.CurrentUser.Id,
          this.mContent.FirstBucketName(),
          ANALYTICS_CONFIGURATION.FIREHOSE_ACTIONS.ACTION_PLAY.value,
          `AMAZON - ${this.videoId}`,
          null,
        );
      }
      this.mVideo.play();
    }

    this.btnPlay[0].classList.add('btn_play');
    this.btnPlay[0].classList.remove('btn_pause');
  }

  playAt(): void {}

  playFromBeginning(): void {}

  resumeVideo(): void {}

  mute(aBool: boolean): void {
    if (this.mVideo) {
      this.mVideo.setMuted(aBool);
      if (aBool) {
        this.btnMute[0].classList.remove('btn_mute');
        this.btnMute[0].classList.add('btn_unmute');
      } else {
        this.btnMute[0].classList.add('btn_mute');
        this.btnMute[0].classList.remove('btn_unmute');
      }
    }
  }

  onTimeChange(): void {
    var aCurrentTime = this.mVideo ? this.mVideo.getPosition() : 0;
    var aDuration = this.mVideo ? this.mVideo.getDuration() : 0;

    if (aDuration == 0 || isNaN(aDuration) || aDuration == null) {
      this.mDuration = this.mVideo.getDuration();
      return;
    }

    this.getCurrentTime().then(() => {
      if (this._constructorParams.onTimeChanged != null) {
        this._constructorParams.onTimeChanged(aCurrentTime, aDuration);
      }

      let aPercent = aCurrentTime / aDuration;
      if (
        aPercent > CrowdHub_App.CONFIG.CONSIDERED_STARTED &&
        this._constructorParams.onWatchedSome != null &&
        this.mWatchedSome == false
      ) {
        this.onWatchedSome();
      }

      if (
        aPercent > CrowdHub_App.CONFIG.CONSIDERED_WATCHEDHALF &&
        this._constructorParams.onWatchedHalf != null &&
        this.mWatchedHalf == false
      ) {
        this.onWatchedHalf();
      }

      if (
        aPercent > CrowdHub_App.CONFIG.CONSIDERED_WATCHED &&
        this._constructorParams.onWatched != null &&
        this.mWatched == false
      ) {
        this.onWatched();
      }

      if (aPercent > CrowdHub_App.CONFIG.CONSIDERED_WATCHEDFULLY && this.mWatchedFull == false) {
        this.onWatchedFully();
      }
    });
  }

  getCurrentTime(): Promise<number> {
    return new Promise((resolve, reject) => {
      if (this.mVideo) {
        resolve(this.mVideo.getPosition());
      } else {
        resolve(0);
      }
    });
  }

  getDurationInMilliseconds(): number {
    if (!this.mDuration) {
      this.mDuration = this.mVideo.getDuration() * 1000;
    }
    return this.mDuration;
  }

  snapToLive(time: moment.Moment, ignorePaused: boolean): void {
    // if i've ended, lets reload the player to clean up just in case we really are over
    if (this.mVideo.getState() == this.playerState.PlayerState.ENDED) {
      this.mVideo.delete();
      this.mDiv.find('#ambience').remove();
      this.mDiv.find('.settings-menu-content').empty();
      this.mDiv.find('#volume-slider-container').empty();
      this.mDiv.find('#scrub-bar-container').empty();
      this.embed();
    } else if (this.mVideo.getState() == this.playerState.PlayerState.IDLE) {
      // if we're sitting idle it means we don't have anything playing but we are still going so lets start our reconnect
      if (!this._audioIsBlocked) {
        this.mVideo.play();
        if (!this._isAttemptingReconnect) {
          this._startBackoffReconnection();
        }
      }
    }
  }

  onWatchedSome(): void {
    this.mWatchedSome = true;

    App.INSTANCE.reportActivity(this.mContent.Id, 'Watched Amazon IVS', 'Amazon IVS 15%', this.mContent.Name);

    if (this._constructorParams.onWatchedSome) {
      this._constructorParams.onWatchedSome();
    }
  }

  onWatchedHalf(): void {
    this.mWatchedHalf = true;

    App.INSTANCE.reportActivity(
      this.mContent.Id,
      'Watched Amazon IVS',
      'Amazon IVS ' + CrowdHub_App.CONFIG.CONSIDERED_WATCHEDHALF * 100 + '%',
      this.videoId,
    );

    if (this._constructorParams.onWatchedHalf) {
      this._constructorParams.onWatchedHalf();
    }
  }

  onWatched(): void {
    this.mWatched = true;

    App.INSTANCE.reportActivity(
      this.mContent.Id,
      'Watched Amazon IVS',
      'Amazon IVS ' + CrowdHub_App.CONFIG.CONSIDERED_WATCHED * 100 + '%',
      this.videoId,
    );

    if (this._constructorParams.onWatched) {
      this._constructorParams.onWatched();
    }
  }

  onWatchedFully(): void {
    this.mWatchedFull = true;

    App.INSTANCE.reportActivity(this.mContent.Id, 'Watched Amazon IVS', 'Amazon IVS 100%', this.videoId);

    if (this._constructorParams.onWatchedFully) {
      this._constructorParams.onWatchedFully();
    }
  }

  onTransitionOut(): void {
    this.destroy();
  }

  appendPlayerTo(where: JQuery): void {
    if (this.mDiv.appendTo) {
      this.mDiv.appendTo(where);
    } else {
      where.append(this.mDiv);
    }
  }

  videoIsLive(): boolean {
    return false;
  }
}
export default AmazonIVSPlayer;
